import type { Member } from './types';

export function hasPermissionGrants(member: Member) {
  if (member.permissionGrants === undefined) {
    return false;
  }

  return member.permissionGrants.length > 0;
}
